// extracted by mini-css-extract-plugin
module.exports = {"titleDiv":"Paginator_titleDiv__3w3pj","titleSty":"Paginator_titleSty__3he_B","paginatorBtnDiv":"Paginator_paginatorBtnDiv__2BYfj","fixedBtnSty":"Paginator_fixedBtnSty__2870e"};